import * as React from "react";

function SvgGq(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 336"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M512.001 112.092H0V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828v102.989z"
          fill="#73AF00"
        />
        <path
          d="M503.172 335.724H8.828A8.829 8.829 0 010 326.896V223.908h512v102.988a8.828 8.828 0 01-8.828 8.828z"
          fill="#FF4B55"
        />
        <path fill="#F5F5F5" d="M0 112.088h512V223.9H0z" />
        <path
          d="M128.095 173.47a8.828 8.828 0 000-10.94L2.335 3.233C.92 4.799 0 6.827 0 9.103v317.793c0 2.276.92 4.305 2.335 5.87l125.76-159.296z"
          fill="#4173CD"
        />
        <path
          d="M253.881 175.896c0 .216-.071 20.968-5.378 31.177h14.913c-5.308-10.208-5.378-30.961-5.378-31.177 0-7.15 7.411-12.832 7.486-12.888l-2.497-3.322c-.194.146-2.664 2.039-4.988 5.114v-5.53h-4.157v5.53c-2.324-3.075-4.793-4.969-4.988-5.114l-2.497 3.322c.075.056 7.484 5.737 7.484 12.888z"
          fill="#B46446"
        />
        <path
          d="M276.745 150.955c-.127 0-.244.033-.37.041-.847-2.438-3.14-4.198-5.866-4.198-.983 0-1.9.248-2.727.653-.881-1.619-2.575-2.731-4.547-2.731-.567 0-1.102.114-1.613.281a7.275 7.275 0 00-6.7-4.438c-3.701 0-6.722 2.774-7.181 6.349a7.298 7.298 0 00-1.132-.114 7.275 7.275 0 00-7.275 7.275c0 .472.053.931.139 1.378a6.205 6.205 0 00-3.925 3.855c-.124-.011-.244-.038-.371-.038a4.157 4.157 0 000 8.314c1.06 0 2.018-.409 2.752-1.064a6.207 6.207 0 003.484 1.064 6.164 6.164 0 003.117-.865c.92.535 1.976.865 3.117.865a6.236 6.236 0 006.236-6.236c0-.264-.046-.514-.077-.769.968.477 2.042.769 3.196.769a7.218 7.218 0 003.916-1.161c1.063 1.922 3.085 3.239 5.437 3.239.505 0 .991-.076 1.461-.19 1.144 1.375 2.846 2.269 4.774 2.269 1.863 0 3.517-.833 4.659-2.129 3.204-.259 5.734-2.913 5.734-6.185a6.24 6.24 0 00-6.238-6.234z"
          fill="#73AF00"
        />
        <path
          d="M270.509 156.151c0-.216.045-.42.064-.631a6.196 6.196 0 01-4.221 1.671 6.223 6.223 0 01-5.196-2.796 6.225 6.225 0 01-5.196 2.796 6.201 6.201 0 01-4.297-1.734c-.648 3.354-3.592 5.89-7.135 5.89-.36 0-.704-.055-1.049-.106.001.036.011.07.011.106 0 2.718-1.749 5.005-4.175 5.859a6.2 6.2 0 002.097.376 6.164 6.164 0 003.117-.865c.92.535 1.976.865 3.117.865a6.236 6.236 0 006.236-6.236c0-.264-.046-.514-.077-.769.968.477 2.042.769 3.196.769a7.218 7.218 0 003.916-1.161c1.063 1.922 3.085 3.239 5.437 3.239.505 0 .991-.076 1.461-.19 1.144 1.375 2.846 2.269 4.773 2.269 1.863 0 3.517-.833 4.659-2.129l.013-.002c-3.769-.274-6.751-3.383-6.751-7.221z"
          fill="#5FA000"
        />
        <path
          d="M255.96 220.321a.783.783 0 01-.739-.527c-.079-.234-2.036-5.706-9.653-5.706h-10.392c-6.161 0-11.171-5.012-11.171-11.171v-68.588a.78.78 0 01.779-.779h64.431a.78.78 0 01.779.779v68.588c0 6.161-5.012 11.171-11.171 11.171h-12.471c-7.663 0-9.634 5.644-9.652 5.702a.777.777 0 01-.738.532h-.002v-.001zm-30.398-85.215v67.809c0 5.3 4.312 9.613 9.613 9.613h10.392c6.169 0 9.155 3.313 10.392 5.303 1.237-1.992 4.223-5.303 10.392-5.303h12.471c5.301 0 9.613-4.313 9.613-9.613v-67.809h-62.873z"
          fill="#464655"
        />
        <path
          d="M247.983 115.795l1.976 3.161 3.725.129-1.751 3.291 1.751 3.291-3.725.129-1.976 3.162-1.974-3.162-3.725-.129 1.75-3.291-1.75-3.291 3.725-.129zm-17.558 2.867l2.659 2.612 3.652-.744-.934 3.608 2.471 2.792-3.592.995-1.181 3.535-2.659-2.613-3.652.745.933-3.609-2.47-2.791 3.592-.995zm-16.847 4.985l3.16 1.978 3.405-1.516-.132 3.725 3.015 2.192-3.292 1.748-.391 3.707-3.16-1.978-3.405 1.516.132-3.725-3.015-2.192 3.292-1.748zm50.439-7.852l-1.976 3.161-3.725.129 1.751 3.291-1.751 3.291 3.725.129 1.976 3.162 1.974-3.162 3.725-.129-1.75-3.291 1.75-3.291-3.725-.129zm17.558 2.867l-2.659 2.612-3.652-.744.934 3.608-2.471 2.792 3.592.995 1.181 3.535 2.659-2.613 3.652.745-.933-3.609 2.47-2.791-3.592-.995zm16.847 4.985l-3.16 1.978-3.405-1.516.132 3.725-3.015 2.192 3.292 1.748.391 3.707 3.16-1.978 3.405 1.516-.132-3.725 3.015-2.192-3.292-1.748z"
          fill="#FFE15A"
        />
      </g>
    </svg>
  );
}

export default SvgGq;
